import { render, staticRenderFns } from "./SigHelpMenuButton.vue?vue&type=template&id=1bab3c25&scoped=true&"
import script from "./SigHelpMenuButton.vue?vue&type=script&lang=js&"
export * from "./SigHelpMenuButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bab3c25",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VImg } from 'vuetify/lib/components/VImg';
import { VMenu } from 'vuetify/lib/components/VMenu';
installComponents(component, {VBtn,VImg,VMenu})
